import { COURSES } from '@lemontaigu/shared';
import type { CourseSlug, MenuSnapshot, SnapshotItem } from '@lemontaigu/shared';
import { getMenuStore } from './store.js';

const courseLabelOf = (slug: string): string => COURSES.find((c) => c.slug === slug)?.label ?? slug;

/** Frozen past-day Menu du Jour snapshots, newest first. */
export function listHistory(limit = 90): Promise<MenuSnapshot[]> {
  return getMenuStore().listHistory(limit);
}

/** Scheduled today/future Menu du Jour days (live `dish_servings`), grouped by date. */
export async function listFuture(todayIso: string): Promise<MenuSnapshot[]> {
  const rows = await getMenuStore().listFutureServings(todayIso);
  const byDate = new Map<string, SnapshotItem[]>();
  for (const { date, dish: d } of rows) {
    if (!d || !d.is_active || d.deleted_at || !(d.menu_types ?? []).includes('daily')) continue;
    const items = byDate.get(date) ?? [];
    items.push({
      dishId: 0,
      title: d.name,
      description: d.description ?? '',
      price: '',
      course: (d.course ?? '') as CourseSlug | '',
      courseLabel: d.course ? courseLabelOf(d.course) : '',
      rank: d.course_position ?? 0,
    });
    byDate.set(date, items);
  }
  return Array.from(byDate, ([date, items]) => ({
    date,
    items: items.sort((a, b) => a.rank - b.rank),
  }));
}
